import React, {useMemo} from "react";
import EmployeesPageHeading from "./heading/EmployeesPageHeading";
import EmployeesDataTable from "./table/EmployeesDataTable";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {useSearchParams} from "react-router-dom";
import {searchParamsToStatusFilter} from "@widgets/employees/overview/heading/ClockedStatusFilter";
import {ClockedFilterStatus} from "@widgets/employees/overview/Employees";

const EmployeesOverview = () => {
    const {dashboardLocation} = useRestaurant();
    const [searchParams, setSearchParams] = useSearchParams();
    const statusFilter: ClockedFilterStatus = useMemo(() => searchParamsToStatusFilter(searchParams), [searchParams]);

    return (
        <>
            <EmployeesPageHeading
                statusFilter={statusFilter}
                setSearchParams={setSearchParams}
            />

            <div className={"mt-8 md:mt-16"}>
                <EmployeesDataTable
                    dashboardLocation={dashboardLocation.id}
                    statusFilter={statusFilter}
                />
            </div>
        </>
    );
};

export default EmployeesOverview;